<template>

<!--  https://stackoverflow.com/questions/19613563/twitter-bootstrap-3-0-row-wider-than-window : container-fluid-->
  <div class="container-fluid page_setup">


    <template v-if="report_main_data.show_sales_totals === 1">

    <div class="row">

      <div class="col-3">
        <div class="box_title">
          Total Sales
        </div>
        <div>
          <table class = "table_box bold_font">
            <tbody>
            <tr class="table_td">
              <td class="total_big padding_left padding_top">${{report_main_data.ALL_TIME.TOTAL}}</td><td class="padding_right padding_top">Total Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.FROOT}}</td><td class="padding_right">Froot Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.NOAHS}}</td><td class="padding_right">Noah's Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.WHITE_LABEL}}</td><td class="padding_right">White Label</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.SPARKIES}}</td><td class="padding_right">Sparkies</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.RICE}}</td><td class="padding_right">Rice Bars</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.ALL_TIME.PLANT}}</td><td class="padding_right">The Plant</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left padding_bottom">${{report_main_data.ALL_TIME.POPPYS}}</td><td class="padding_right padding_bottom">Poppy's</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-3">
        <div class="box_title">
          Month Total:
          <select class="select_field" @change="changeMonth($event)" v-model="selected_month_id">
            <option v-for="month in report_main_data.SELECT_MONTH" :value="month.month_id"  :key="month.month_id">{{month.month_name}}</option>
          </select>
          <select class="select_field" @change="changeYear($event)" v-model="selected_year_id">
            <option v-for="year in report_main_data.SELECT_YEAR" :value="year.year_id"  :key="year.year_id">{{year.year_name}}</option>
          </select>
        </div>
        <div>
          <table class = "table_box bold_font">
            <tbody>
            <tr class="table_td">
              <td class="total_big padding_left padding_top">${{report_main_data.CUSTOM_MONTH_YEAR.TOTAL}}</td><td class="padding_right padding_top">Total Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.FROOT}}</td><td class="padding_right">Froot Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.NOAHS}}</td><td class="padding_right">Noah's Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.WHITE_LABEL}}</td><td class="padding_right">White Label</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.SPARKIES}}</td><td class="padding_right">Sparkies</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.RICE}}</td><td class="padding_right">Rice Bars</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.CUSTOM_MONTH_YEAR.PLANT}}</td><td class="padding_right">The Plant</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left padding_bottom">${{report_main_data.CUSTOM_MONTH_YEAR.POPPYS}}</td><td class="padding_right padding_bottom">Poppy's</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-3">
        <div class="box_title">
          Trailing 30 days
        </div>
        <div>
          <table class = "table_box bold_font">
            <tbody>
            <tr class="table_td">
              <td class="total_big padding_left padding_top">${{report_main_data.TRAILING_30_DAYS.TOTAL}}</td><td class="padding_right padding_top">Total Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.FROOT}}</td><td class="padding_right">Froot Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.NOAHS}}</td><td class="padding_right">Noah's Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.WHITE_LABEL}}</td><td class="padding_right">White Label</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.SPARKIES}}</td><td class="padding_right">Sparkies</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.RICE}}</td><td class="padding_right">Rice Bars</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_30_DAYS.PLANT}}</td><td class="padding_right">The Plant</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left padding_bottom">${{report_main_data.TRAILING_30_DAYS.POPPYS}}</td><td class="padding_right padding_bottom">Poppy's</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-3">
        <div class="box_title">
          Trailing 14 days
        </div>
        <div>
          <table class = "table_box bold_font">
            <tbody>
            <tr class="table_td">
              <td class="total_big padding_left padding_top">${{report_main_data.TRAILING_14_DAYS.TOTAL}}</td><td class="padding_right padding_top">Total Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.FROOT}}</td><td class="padding_right">Froot Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.NOAHS}}</td><td class="padding_right">Noah's Sales</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.WHITE_LABEL}}</td><td class="padding_right">White Label</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.SPARKIES}}</td><td class="padding_right">Sparkies</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.RICE}}</td><td class="padding_right">Rice Bars</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left">${{report_main_data.TRAILING_14_DAYS.PLANT}}</td><td class="padding_right">The Plant</td>
            </tr>
            <tr class="table_td">
              <td class="padding_left padding_bottom">${{report_main_data.TRAILING_14_DAYS.POPPYS}}</td><td class="padding_right padding_bottom">Poppy's</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    </template>


    <div class="row">

      <template v-if="report_main_data.show_sales_totals === 1">
        <div class="col-7">
          <div class="graph_background">

          <template v-if="stackit">
            <line-chart :stacked=stackit ytitle="Sales $" prefix="$ " :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA',]" :data=report_main_data.MULTI_GRAPH_DATA></line-chart>
          </template>
          <template v-else>
            <line-chart :stacked=stackit ytitle="Sales $" prefix="$ " :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA','#000000']" :data=report_main_data.MULTI_GRAPH_DATA_TOTAL></line-chart>
          </template>


          </div>

          <div>
            <template v-if="stackit === true">
              <button class="stack_button" @click = "stack_it_toggle">Regular</button>
            </template>
            <template v-else>
              <button class="stack_button" @click = "stack_it_toggle">Stacked</button>
            </template>
          </div>


        </div>
      </template>

      <div class="col-5">

        <div class="update_background">

          <template v-if="is_updating_orders">
            Updating  Orders and Activity Database ...
          </template>
          <template v-else>
            <button class="update_button" @click="update_orders_database()">Update Orders and Track Activity Database</button>
          </template>
          <div class="last_update_text">
            Last update: {{report_main_data.LAST_UPDATE_ORDERS}}
          </div>

          <template v-if="!is_updating_orders">

            <template v-if="is_updating_account_receivable">
              Updating Account Receivables ...
            </template>
            <template v-else>
              <button class="update_button" @click="update_account_receivables()">Update Account Receivables (takes a few minutes)</button>
            </template>
            <div class="last_update_text">
              Last update: {{report_main_data.LAST_UPDATE_AR}}
            </div>
          </template>

          <template v-if="is_updating_customers">
            Updating  Customer and Employee Database ...
          </template>
          <template v-else>
            <button class="update_button" @click="update_customer_database()">Update Customer and Employee Database (takes a few minutes)</button>
          </template>
          <div class="last_update_text">
            Last update: {{report_main_data.LAST_UPDATE_CUSTOMERS}}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        stackit: false,
        selected_month_id: 1,
        selected_year_id: 2023,
      }
    },
    computed: {
      ...mapGetters({
        update_order_status: 'admin/update_order_status',
        update_customer_status: 'admin/update_customer_status',
        update_account_receivables_status: 'admin/update_account_receivables_status',
        is_updating_orders: 'admin/is_updating_orders',
        is_updating_customers: 'admin/is_updating_customers',
        is_updating_account_receivable: 'admin/is_updating_account_receivable',
        report_main_data: 'admin/report_main_data',
      }),
    },
    watch: {
      update_order_status: async function () {
        this.get_report_main_data();
      },
      update_customer_status: async function () {
        this.get_report_main_data();
      },
      update_account_receivables_status: async function () {
        this.get_report_main_data();
      },
      report_main_data: async function () {
      },
    },
    mounted() {
      this.selected_month_id = Number(localStorage.getItem('set_month_id'));
      if(parseInt(this.selected_month_id) < 1)
      {
        localStorage.setItem('set_month_id', "4");
        this.selected_month_id = Number(localStorage.getItem('set_month_id'));
      }
      this.selected_year_id    = Number(localStorage.getItem('set_year_id'));
      if(parseInt(this.selected_year_id) < 1)
      {
        localStorage.setItem('set_year_id', "2023");
        this.selected_year_id = Number(localStorage.getItem('set_year_id'));
      }

      this.get_report_main_data();
    },
    methods: {
      changeMonth(event) {
        this.selected_month_id = event.target.options[event.target.options.selectedIndex].value;
        localStorage.setItem('set_month_id', this.selected_month_id);
        this.$store.dispatch('admin/getReportMainData',{'custom_month': this.selected_month_id , 'custom_year' : this.selected_year_id});
      },
      changeYear(event) {
        this.selected_year_id = event.target.options[event.target.options.selectedIndex].value;
        localStorage.setItem('set_year_id', this.selected_year_id);
        this.$store.dispatch('admin/getReportMainData',{'custom_month': this.selected_month_id , 'custom_year' : this.selected_year_id});
      },
      get_report_main_data () {
        this.$store.dispatch('admin/getReportMainData',{'custom_month': this.selected_month_id , 'custom_year' : this.selected_year_id});
      },
      update_orders_database () {
        this.$store.dispatch('admin/emptyLoadedLists');
        this.$store.dispatch('admin/updateOrdersDatabase');
      },
      update_customer_database () {
        this.$store.dispatch('admin/emptyLoadedLists');
        this.$store.dispatch('admin/updateCustomerDatabase');
      },
      update_account_receivables () {
        this.$store.dispatch('admin/emptyLoadedLists');
        this.$store.dispatch('admin/updateAccountReceivables');
      },
      stack_it_toggle () {
        if(this.stackit === true) {
          this.stackit = false;
        } else {
          this.stackit = true;
        }
      },

    }
  }
</script>


<style scoped>

.select_field {
  color: #3951a9;
  font-weight: bolder;
  background-color: #e8e9ee;
  border-style: none;
  margin-bottom: 0px;
  margin-top: 0px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: smaller;
}

.page_setup {
  background: #e8e9ee;
}

.table_td {
  text-align: left;
  white-space:nowrap;
  font-size: larger;
}

.padding_left {
  padding-left: 15px;
}

.padding_right {
  padding-right: 10px;
}

.padding_top {
  padding-top: 10px;
}

.padding_bottom {
  padding-bottom: 10px;
}

.total_big {
  font-size: 26px;
  padding-right: 10px;
}

.box_title {
  color: black;
  font-size: 22px;
  padding-top: 15px;
  padding-bottom: 3px;
  font-weight: bolder;
}

.bold_font {
  font-weight: bolder;
}

.table_box {
  //border: 1px solid red;
  border-radius: 7px;
  width: 100%;

//margin: 0px 0px;
  background: #FFF;
}

.graph_background {
  border-radius: 7px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10pX;
  background: #FFF;
}

.update_background {
  border-radius: 7px;
  margin-top: 20px;
  margin-bottom: 500px;
  padding: 27pX;
  background: #FFF;
}

.update_button {
  color: black;
  width: 95%;
  background-color: lightblue;
  //padding-left: 10px;
  //padding-right: 10px;
  padding-top: 5px;
  border-radius: 7px;
  border-style: hidden;
  font-size: larger;
  font-weight: 500;
  margin-top: 15px;
  margin-bottom: 0px;
}

.stack_button {
  color: black;
  background-color: lightblue;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 5px;
  border-radius: 7px;
  border-style: hidden;
  font-size: larger;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 0px;
}

.last_update_text {
  margin-top: 5px;
  margin-bottom: 10px;
}



.down_button {
  width: 54px;
  color: white;
  background-color: royalblue;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  font-size: smaller;
  font-weight: 700;
  margin: 2px;
}




</style>
